import { render, staticRenderFns } from "./view-chat.vue?vue&type=template&id=518f53e2&scoped=true"
import script from "./view-chat.vue?vue&type=script&lang=js"
export * from "./view-chat.vue?vue&type=script&lang=js"
import style0 from "./view-chat.vue?vue&type=style&index=0&id=518f53e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f53e2",
  null
  
)

export default component.exports